<template>
    <n-dialog
        v-model:visible="visible"
        :class="{ 'enterprise-dissolve-dialog-host': mode >= 3 }"
    >
        <div class="create-content" :class="{'desktop-create-content': isDesktop}" v-if="mode == 0">
            <div class="create-content-sub_title">
                {{ $t('account_enterprise_table_not_data_create_title') }}
            </div>
            <div class="create-content-input">
                <PDFInput inputWidth="100%" :isShowNumber="true" :inputMaxLength="50" :inputMinLength="1" inputHeight="40px" 
                @handleChange="handleInputChange" :placeholderString="$t(`account_enterprise_table_not_data_create_placeholder`)"/>
            </div>
            <div class="create-content-button">
                <div class="create-content-button-item_cancel" @click="handleCancel">
                    <div class="create-content-button-item_cancel_text">
                        {{ $t('accountLoginOutBtn1') }}
                    </div>
                </div>
                <div class="create-content-button-item_confirm" @click="handleCreate">
                    <div class="create-content-button-item_confirm_text">
                        {{ $t('account_enterprise_table_not_data_create_btn') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="add-member-content" :class="{'desktop-add-member-content': isDesktop}" v-if="mode == 1 || mode == 2">
            <div class="add-member-content-title">
                {{ mode == 1 ? $t('account_enterprise_add_member') : $t('account_enterprise_edit_member') }}
            </div>
            <div class="add-member-content-input">
                <div class="add-member-content-input-title">
                    <span class="import-title">*</span>
                   {{$t('dcolingo_email')}}:
                </div>
                <div class="add-member-content-input-item">
                    <PDFInput inputWidth="100%" inputHeight="40px" :isDisable="mode == 2" ref="emailInput"
                    @handleChange="handleEmailInputChange" :placeholderString="$t(`art_create_placeholder`)"/>
                </div>
            </div>
            <div class="add-member-content-input">
                <div class="add-member-content-input-title">
                    <span class="import-title" style="opacity: 0;">*</span>
                   {{$t('account_enterprise_table_header_alias')}}:
                </div>
                <div class="add-member-content-input-item">
                    <PDFInput inputWidth="100%" inputHeight="40px" ref="aliasInput" :inputMaxLength="12"
                    @handleChange="handleAliasInputChange" :placeholderString="$t(`art_create_placeholder`)"/>
                </div>
            </div>
            <div class="add-member-content-select">
                <div class="add-member-content-select-title">
                    <span class="import-title">*</span>
                   {{$t('account_enterprise_add_member_role')}}:
                </div>
                <div class="add-member-content-select-item">
                    <el-select class="custom-select" size="large" v-model="memberForm.role" @change="handleRoleChange" :placeholder="$t('art_create_placeholder')">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        />
                    </el-select>
                </div>
            </div>
            <div class="permission-content-select">
                <div class="permission-content-select-title">
                    <span class="import-title" style="opacity: 0;">*</span>
                   {{$t('account_enterprise_table_header_permission')}}:
                </div>
                <div class="permission-content-select-item">
                    <div class="permission-content-select-item-box">
                        <div class="permission-content-select-item-title-box">
                            <span class="permission-content-select-item-title-box-title">{{ $t('account_enterprise_add_member_file') }}</span>
                            <el-popover
                                placement="right"
                                width="230"
                                trigger="hover"
                                effect="dark"
                                popper-class="custom-popover"
                            >
                                <template #reference>
                                    <i class="iconfont icon-icon_question" style="color:#8C8C8C; font-size: 14px; " />
                                </template>
                                <div class="popoverDiv">
                                    <div style="font-size: 12px;" >{{ $t('account_enterprise_add_member_file_tip') }}</div>
                                </div>
                            </el-popover>
                        </div>
                        <div class="permission-checkbox">
                            <i class="iconfont icon-icon_nchecked_n"
                                :class="`${memberForm.fileLook ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                                @click.stop="memberForm.fileLook = !memberForm.fileLook" />
                            <div class="checkDev_tipsTitle">
                                <p @click.stop>{{ $t("account_enterprise_add_member_permission_viewer") }}</p>
                            </div>
                        </div>
                        <div class="permission-checkbox">
                            <i class="iconfont icon-icon_nchecked_n"
                                :class="`${memberForm.fileDownload ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                                @click.stop="memberForm.fileDownload = !memberForm.fileDownload" />
                            <div class="checkDev_tipsTitle">
                                <p @click.stop>{{ $t("account_enterprise_permission_download") }}</p>
                            </div>
                        </div>
                        <!-- <div class="permission-checkbox">
                            <i class="iconfont icon-icon_nchecked_n"
                                :class="`${memberForm.fileEdit ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                                @click.stop="memberForm.fileEdit = !memberForm.fileEdit" />
                            <div class="checkDev_tipsTitle">
                                <p @click.stop>{{ $t("account_enterprise_permission_edit") }}</p>
                            </div>
                        </div> -->
                    </div>
                    <div class="permission-content-select-item-box" style="margin-top: 20px;">
                        <div class="permission-content-select-item-title-box">
                            <span class="permission-content-select-item-title-box-title">{{ $t('account_enterprise_add_member_art') }}</span>
                            <el-popover
                                placement="right"
                                width="230"
                                trigger="hover"
                                effect="dark"
                                popper-class="custom-popover"
                            >
                                <template #reference>
                                    <i class="iconfont icon-icon_question" style="color:#8C8C8C; font-size: 14px; " />
                                </template>
                                <div class="popoverDiv">
                                    <div style="font-size: 12px;" >{{ $t('account_enterprise_add_member_art_tip') }}</div>
                                </div>
                            </el-popover>
                        </div>
                        <div class="permission-checkbox">
                            <i class="iconfont icon-icon_nchecked_n"
                                :class="`${memberForm.artUse ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                                @click.stop="memberForm.artUse = !memberForm.artUse" />
                            <div class="checkDev_tipsTitle">
                                <p @click.stop>{{ $t("account_enterprise_add_member_permission_use") }}</p>
                            </div>
                        </div>
                        <div class="permission-checkbox">
                            <i class="iconfont icon-icon_nchecked_n"
                                :class="`${memberForm.artEdit ? 'icon-icon_check_n' : 'icon-icon_nchecked_n'}`"
                                @click.stop="memberForm.artEdit = !memberForm.artEdit" />
                            <div class="checkDev_tipsTitle">
                                <p @click.stop>{{ $t("account_enterprise_permission_edit") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="add-member-content-button">
                <div class="add-member-content-button-item_confirm" :class="{'add-member-content-button-item_confirm-disabled': !checkAddMember()}" @click="handleMemberSave">
                    <div class="add-member-content-button-item_confirm_text">
                        {{ $t('account_enterprise_add_member_btn_save') }}
                    </div>
                </div>
            </div>
            <div class="back-btn" @click="handleCancel">
                <div class="back-btn-text">
                    <i class="iconfont icon-icon_close" />
                </div>
            </div>
        </div>
        <div class="enterprise-dialog enterprise-remove-dialog" v-if="mode == 3">
            <div class="enterprise-dialog-title">{{ $t('enterprise_ui_remove_member') }}</div>
            <div class="enterprise-dialog-desc">{{ deleteMemberPrompt }}</div>
            <div v-if="removalAttempt?.accepted" class="enterprise-dialog-desc" role="status">{{ $t('enterprise_management_processing') }}</div>
            <div class="enterprise-dialog-btns">
                <button class="enterprise-dialog-btn-cancel" type="button" :disabled="deletingMember" @click="handleCancel">
                    {{ $t('accountLoginOutBtn1') }}
                </button>
                <button
                    class="enterprise-dialog-btn-confirm enterprise-dialog-enabled"
                    :class="{ 'enterprise-dialog-submitting': deletingMember }"
                    type="button"
                    :disabled="deletingMember"
                    @click="handleDelete"
                >
                    {{ $t(deletingMember ? 'enterprise_ui_removing' : removalAttempt?.accepted ? 'enterprise_management_query_result' : 'enterprise_ui_confirm_remove') }}
                </button>
            </div>
            <div class="enterprise-dialog-status-tip">
                <span class="enterprise-dialog-status-icon enterprise-dialog-status-icon-warning" aria-hidden="true"></span>
                <span class="enterprise-dialog-tip-text enterprise-dialog-tip-danger">{{ $t('enterprise_ui_remove_member_warning') }}</span>
            </div>
        </div>
        <!-- 解散企业自定义弹窗（模板对齐） -->
        <div class="enterprise-dialog" v-if="mode == 4">
            <div class="enterprise-dialog-title">{{ $t('account_enterprise_dissolve_title') }}</div>
            <div class="enterprise-dialog-desc">{{ $t('account_enterprise_dissolve_tips') }}</div>
            <div class="enterprise-dialog-check-row" :class="{ 'enterprise-dialog-checked': dissolveChecked }" @click="dissolveChecked = !dissolveChecked">
                <div class="enterprise-dialog-checkbox" :class="{ 'enterprise-dialog-checked': dissolveChecked }">
                    <svg v-if="dissolveChecked" width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="check-svg">
                        <path d="M11.48 2.95c-.07.02-.13.06-.13.06-.05.04-3.07 3.06-3.07 3.06L5.25 9.08 3.96 7.79c-1.29-1.28-1.38-1.32-1.38-1.32-.09-.05-.22-.05-.23-.05-.13 0-.23.04-.23.04-.1.03-.19.11-.19.11-.09.08-.13.17-.13.17-.03.07-.03.11-.03.11 0 .04 0 .14 0 .14v.04c-.02.11.04.2.04.2.07.11.36.4.36.4.2.21.97.98.97.98l1.5 1.49c.28.26.39.33.39.33.07.06.18.04.18.04h.1c.07 0 .14-.03.14-.03.08-.07.32-.28.32-.28.24-.22.8-.76.8-.76l2.28-2.29c2.09-2.1 2.7-2.71 2.7-2.71.62-.62.65-.69.65-.69.04-.08.04-.24.04-.24 0-.1 0-.14 0-.14 0-.04-.04-.11-.04-.11-.05-.08-.13-.17-.13-.17-.09-.08-.18-.12-.18-.12-.09-.04-.21-.04-.21-.04-.12 0-.19.03-.19.03z" fill="#FFFFFF"/>
                    </svg>
                </div>
                <div class="enterprise-dialog-check-text">{{ $t('enterprise_ui_dissolve_acknowledge') }}</div>
            </div>
            <div class="enterprise-dialog-btns">
                <div class="enterprise-dialog-btn-cancel" @click="handleCancel">{{ $t('cancel') }}</div>
                <div class="enterprise-dialog-btn-confirm" :class="{ 'enterprise-dialog-enabled': dissolveChecked }" @click="dissolveChecked && handleDissolve()">{{ $t('accountLoginOutBtn2') }}</div>
            </div>
            <div class="enterprise-dialog-status-tip">
                <template v-if="!dissolveChecked">
                    <span class="enterprise-dialog-status-icon enterprise-dialog-status-icon-info" aria-hidden="true"></span>
                    <span class="enterprise-dialog-tip-text enterprise-dialog-tip-gray">{{ $t('enterprise_ui_confirm_checkbox_hint') }}</span>
                </template>
                <template v-else>
                    <span class="enterprise-dialog-status-icon enterprise-dialog-status-icon-warning" aria-hidden="true"></span>
                    <span class="enterprise-dialog-tip-text enterprise-dialog-tip-danger">{{ $t('enterprise_ui_dissolve_warning') }}</span>
                </template>
            </div>
        </div>
        <!-- 退出企业自定义弹窗（模板对齐） -->
        <div class="enterprise-dialog" v-if="mode == 5">
            <div class="enterprise-dialog-title">{{ $t('account_enterprise_quit_title') }}</div>
            <div class="enterprise-dialog-desc">{{ $t('account_enterprise_quit_tips') }}</div>
            <div class="enterprise-dialog-check-row" :class="{ 'enterprise-dialog-checked': exitChecked }" @click="exitChecked = !exitChecked">
                <div class="enterprise-dialog-checkbox" :class="{ 'enterprise-dialog-checked': exitChecked }">
                    <svg v-if="exitChecked" width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="check-svg">
                        <path d="M11.48 2.95c-.07.02-.13.06-.13.06-.05.04-3.07 3.06-3.07 3.06L5.25 9.08 3.96 7.79c-1.29-1.28-1.38-1.32-1.38-1.32-.09-.05-.22-.05-.23-.05-.13 0-.23.04-.23.04-.1.03-.19.11-.19.11-.09.08-.13.17-.13.17-.03.07-.03.11-.03.11 0 .04 0 .14 0 .14v.04c-.02.11.04.2.04.2.07.11.36.4.36.4.2.21.97.98.97.98l1.5 1.49c.28.26.39.33.39.33.07.06.18.04.18.04h.1c.07 0 .14-.03.14-.03.08-.07.32-.28.32-.28.24-.22.8-.76.8-.76l2.28-2.29c2.09-2.1 2.7-2.71 2.7-2.71.62-.62.65-.69.65-.69.04-.08.04-.24.04-.24 0-.1 0-.14 0-.14 0-.04-.04-.11-.04-.11-.05-.08-.13-.17-.13-.17-.09-.08-.18-.12-.18-.12-.09-.04-.21-.04-.21-.04-.12 0-.19.03-.19.03z" fill="#FFFFFF"/>
                    </svg>
                </div>
                <div class="enterprise-dialog-check-text">{{ $t('enterprise_ui_leave_acknowledge') }}</div>
            </div>
            <div class="enterprise-dialog-btns">
                <div class="enterprise-dialog-btn-cancel" @click="handleCancel">{{ $t('cancel') }}</div>
                <div class="enterprise-dialog-btn-confirm" :class="{ 'enterprise-dialog-enabled': exitChecked }" @click="exitChecked && handleQuit()">{{ $t('accountLoginOutBtn2') }}</div>
            </div>
            <div class="enterprise-dialog-status-tip">
                <template v-if="!exitChecked">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0"><path d="M6.69238 0.60156q-1.16211 0.04102-2.22851 0.50586-1.06299 0.46143-1.90381 1.26807-0.8374 0.80322-1.34326 1.85254-0.48877 1.0083-0.60157 2.15674-0.02734 0.19482-0.02734 0.61523 0 0.42041 0.02734 0.61523 0.11279 1.14844 0.60157 2.15674 0.65967 1.40137 1.89697 2.33789 1.24072 0.93652 2.75146 1.20313 0.5332 0.09912 1.13477 0.09912 0.75537 0 1.43213-0.15381 0.68018-0.15381 1.35351-0.4751 1.26123-0.61865 2.16358-1.70215 0.90234-1.0835 1.25439-2.44384 0.29395-1.11768 0.18116-2.25244-0.11279-1.13477-0.60157-2.17041-0.58789-1.20313-1.62011-2.08497-1.02881-0.88184-2.31397-1.2749-1.0083-0.30762-2.15674-0.25293z m0.96729 1.18946q1.07666 0.14014 1.99267 0.68017 0.91602 0.54004 1.56201 1.4082 0.82715 1.104 1.00831 2.54639 0.01367 0.16748 0.01367 0.57422 0 0.40674-0.01367 0.57422-0.14014 1.16211-0.7212 2.12939-0.58105 0.96387-1.53466 1.62354-0.4751 0.33496-1.04932 0.56055-0.57422 0.22217-1.18945 0.30761-0.25293 0.04102-0.72803 0.04102-0.4751 0-0.72803-0.04102-1.07666-0.15381-1.95849-0.68701-0.88184-0.5332-1.52784-1.3877-0.82715-1.104-1.0083-2.54638-0.01367-0.16748-0.01367-0.57422 0-0.40674 0.01367-0.57422 0.14014-1.12109 0.66993-2.05078 0.5332-0.92969 1.43212-1.58936 0.54346-0.40674 1.20655-0.66992 0.6665-0.2666 1.32617-0.3247l0.25293-0.02735q0.0957-0.01367 0.4751 0 0.37939 0.01367 0.51953 0.02735z m-0.75879 2.31054q-0.18115 0.02734-0.32129 0.16748-0.2085 0.21191-0.15381 0.50586 0.05469 0.29395 0.32129 0.42041 0.09912 0.04102 0.25293 0.04102 0.25293 0 0.42041-0.16748 0.12646-0.12646 0.15381-0.30762 0.05469-0.29395-0.15723-0.50244-0.2085-0.21191-0.51611-0.15723z m-0.05469 2.33789q-0.25293 0.08545-0.37939 0.30762l-0.04102 0.08545 0 2.46436q0 0.18115 0.03418 0.2666 0.0376 0.08203 0.11963 0.16748 0.08545 0.08203 0.18799 0.1333 0.10596 0.04785 0.23242 0.04785 0.12646 0 0.229-0.04785 0.10596-0.05127 0.18799-0.1333 0.08545-0.08545 0.11963-0.16748 0.0376-0.08545 0.0376-0.2666l0-2.46436-0.04102-0.08545q-0.09912-0.18115-0.28027-0.2666-0.08545-0.04102-0.22559-0.04785-0.14014-0.00684-0.18115 0.00683z" fill="#94A3B8"/></svg>
                    <span class="enterprise-dialog-tip-text enterprise-dialog-tip-gray">{{ $t('enterprise_ui_confirm_checkbox_hint') }}</span>
                </template>
                <template v-else>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0"><path d="M6.69238 0.60156q-1.16211 0.04102-2.22851 0.50586-1.06299 0.46143-1.90381 1.26807-0.8374 0.80322-1.34326 1.85254-0.48877 1.0083-0.60157 2.15674-0.02734 0.19482-0.02734 0.61523 0 0.42041 0.02734 0.61523 0.11279 1.14844 0.60157 2.15674 0.65967 1.40137 1.89697 2.33789 1.24072 0.93652 2.75146 1.20313 0.5332 0.09912 1.13477 0.09912 0.75537 0 1.43213-0.15381 0.68018-0.15381 1.35351-0.4751 1.26123-0.61865 2.16358-1.70215 0.90234-1.0835 1.25439-2.44384 0.29395-1.11768 0.18116-2.25244-0.11279-1.13477-0.60157-2.17041-0.58789-1.20313-1.62011-2.08497-1.02881-0.88184-2.31397-1.2749-1.0083-0.30762-2.15674-0.25293z m0.96729 1.18946q1.07666 0.14014 1.99267 0.68017 0.91602 0.54004 1.56201 1.4082 0.82715 1.104 1.00831 2.54639 0.01367 0.16748 0.01367 0.57422 0 0.40674-0.01367 0.57422-0.14014 1.16211-0.7212 2.12939-0.58105 0.96387-1.53466 1.62354-0.4751 0.33496-1.04932 0.56055-0.57422 0.22217-1.18945 0.30761-0.25293 0.04102-0.72803 0.04102-0.4751 0-0.72803-0.04102-1.07666-0.15381-1.95849-0.68701-0.88184-0.5332-1.52784-1.3877-0.82715-1.104-1.0083-2.54638-0.01367-0.16748-0.01367-0.57422 0-0.40674 0.01367-0.57422 0.14014-1.12109 0.66993-2.05078 0.5332-0.92969 1.43212-1.58936 0.54346-0.40674 1.20655-0.66992 0.6665-0.2666 1.32617-0.3247l0.25293-0.02735q0.0957-0.01367 0.4751 0 0.37939 0.01367 0.51953 0.02735z m-0.75879 2.31054q-0.0957 0.01367-0.17432 0.05127-0.0752 0.03418-0.15381 0.12647-0.0752 0.08887-0.11279 0.16748-0.03418 0.0752-0.03418 0.25635l0 2.46435 0.04102 0.08545q0.04443 0.06836 0.12646 0.15381 0.08545 0.08203 0.16065 0.12646 0.07861 0.04102 0.24609 0.04102 0.16748 0 0.24268-0.04102 0.07861-0.04443 0.16064-0.12646 0.08545-0.08545 0.12988-0.15381l0.04102-0.08545 0-2.33789q0-0.2666-0.02051-0.3418-0.02051-0.07861-0.07861-0.16064l-0.01367-0.01367q-0.09912-0.12646-0.2461-0.18116-0.14697-0.05811-0.31445-0.03076z m-0.05469 4.67578q-0.2085 0.05811-0.32129 0.22559-0.11279 0.16748-0.09912 0.37256 0.01367 0.20166 0.15381 0.35547 0.08545 0.08203 0.15381 0.12646 0.21191 0.0957 0.42041 0.03418 0.2085-0.06494 0.33496-0.24609 0.12646-0.18115 0.08545-0.40674-0.01367-0.10938-0.05127-0.17773-0.03418-0.07178-0.11963-0.14014-0.08203-0.07178-0.16064-0.11279-0.0752-0.04443-0.19483-0.05127-0.11621-0.00684-0.20166 0.0205z" fill="#C2410C"/></svg>
                    <span class="enterprise-dialog-tip-text enterprise-dialog-tip-orange">{{ $t('enterprise_ui_leave_warning') }}</span>
                </template>
            </div>
        </div>
    </n-dialog>
</template>

<script setup lang="ts">
import useUserStore, { useUserStoreHook } from '~/store/modules/user'
import PDFInput from "@/components/Index/components/input/PDFInput.vue"
import AccountServer from '~/services/AccountServer'
import LegacyEnterpriseServer from '~/services/LegacyEnterpriseServer'
import { runLegacyMemberRemoval, type MemberRemovalAttempt } from '~/utils/legacyEnterpriseRemoval'
import { getEnterpriseWorkspaceMode } from '~/utils/enterpriseManagement'
import { NetCode } from '~/types/const'
import EventBus from 'vue3-eventbus'
import { type EnterpriseInfo } from '~/services/AccountServer/types'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import Toast from '@/utils/toast'
import {PermissionUtils, EnterpriseMemberPermission, type EnterpriseMember } from '~/services/AccountServer/types'
const userStore = useUserStore()
const { userInfo, bizTeamInfo} = storeToRefs(userStore)
const {t} = useI18n()
let call = defineEmits(["addMemberCall", "editMemberCall", "deleteMemberCall", "dissolveEnterpriseCall", "quitEnterpriseCall"])
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const visible = ref(false)
const inputValue = ref('')
const mode = ref(0)  // 0 创建 1 添加成员 2 编辑成员 3 删除成员 4 解散企业 5 退出企业
const dissolveChecked = ref(false)  // 解散企业：二次确认勾选
const exitChecked = ref(false)  // 退出企业：二次确认勾选
const deletingMember = ref(false)
const removalAttempt = ref<MemberRemovalAttempt | null>(null)
const removalAttempts = new Map<string, MemberRemovalAttempt>()
let removalRevision = 0
const removalScope = () => {
    const member = currentMember.value as any
    return `legacy-enterprise-member:remove:${userInfo.value?.id}:${bizTeamInfo.value?.id}:${bizTeamInfo.value?.legacyMigrationNo}:${member?.id}`
}
function rememberRemoval(scope: string, attempt: MemberRemovalAttempt | null) {
    if (attempt) removalAttempts.set(scope, attempt)
    else removalAttempts.delete(scope)
    if (scope === removalScope()) removalAttempt.value = attempt
    try {
        if (attempt) window.sessionStorage.setItem(scope, JSON.stringify(attempt))
        else window.sessionStorage.removeItem(scope)
    } catch {}
}
function restoreRemoval() {
    const scope = removalScope()
    removalAttempt.value = removalAttempts.get(scope) || null
    try {
        const stored = JSON.parse(window.sessionStorage.getItem(scope) || 'null')
        if (stored && /^[a-zA-Z0-9_-]{8,64}$/.test(stored.requestId) && typeof stored.accepted === 'boolean') {
            removalAttempt.value = stored
        }
    } catch {}
}
const emailInput = ref()
const aliasInput = ref()
const currentMember = ref({})
const deleteMemberPrompt = computed(() => {
    const member = currentMember.value as any
    const account = String(member?.userAccount || '').trim()
    const regionLabel = String(member?.deleteRegionLabel || '').trim()
    if (account && regionLabel) return t('enterprise_ui_remove_member_from_region', { account, region: regionLabel })
    if (account) return t('enterprise_ui_remove_member_confirm', { account })
    return t('delete_enterprise_member_tips')
})
const options = ref([
    {value: 2, label: t('account_enterprise_add_member_role_admin')},
    {value: 3, label: t('account_enterprise_table_header_member')}
])
const memberForm = ref({
    email: '',
    alias: '',
    role: null,
    fileLook: false,
    fileEdit: false,
    fileDownload: false,
    artUse: false,
    artEdit: false
})

const handleRoleChange = (value: number)=>{
    console.log(value)
    memberForm.value.role = value
}

const handleCreate = () =>{
    console.log('退出登录', inputValue.value)
    AccountServer.createAccountEnterprise({
        businessName: inputValue.value
    }).then((res)=>{
        console.log(res)
        if(res.code === NetCode.SUCCESS){
            bizTeamInfo.value = res.data as EnterpriseInfo
            userStore.getUserInfo()
            EventBus.emit('createAccountEnterprise')
            visible.value = false
        }else{
            Toast(res.message)
        }
    })
}

const handleDelete = async () =>{
    if (!currentMember.value || deletingMember.value) return
    const revision = ++removalRevision
    const scope = removalScope()
    const token = userStore.token
    const current = () => revision === removalRevision && scope === removalScope() && token === userStore.token && visible.value
    deletingMember.value = true
    try {
        const member = currentMember.value as any
        if (typeof member.deleteAction === 'function') {
            const deleted = await member.deleteAction()
            if (deleted === false) return
        } else {
            if (getEnterpriseWorkspaceMode(bizTeamInfo.value) === 'legacy-cross') {
                const teamId = Number(bizTeamInfo.value.id)
                const attempt = removalAttempt.value || {
                    requestId: `LMREMOVE_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`,
                    accepted: false,
                }
                const result = await runLegacyMemberRemoval({
                    attempt,
                    remove: requestId => AccountServer.deleteAccountMember({ memberId: member.id, requestId }),
                    query: requestId => LegacyEnterpriseServer.memberStatus(teamId, requestId),
                    remember: value => rememberRemoval(scope, value),
                })
                if (!current()) return
                if (result.state !== 'success') {
                    Toast(result.state === 'pending' ? t('enterprise_management_processing')
                        : result.state === 'error' && result.message ? result.message : t('enterprise_ui_remove_member_failed'))
                    return
                }
            } else {
                const res = await AccountServer.deleteAccountMember({ memberId: member.id })
                if (!current()) return
                if (res.code !== NetCode.SUCCESS) {
                    Toast(res.message)
                    return
                }
            }
        }
        if (!current()) return
        call('deleteMemberCall')
        visible.value = false
    } catch (error: any) {
        if (current()) Toast(error?.message || t('enterprise_ui_remove_member_failed'))
    } finally {
        if (revision === removalRevision) deletingMember.value = false
    }
}

// 解散企业
const handleDissolve = () =>{
    AccountServer.deleteEnterprise().then((res)=>{
        if(res.code === NetCode.SUCCESS){
            call('dissolveEnterpriseCall')
            visible.value = false
        }else{
            Toast(res.message)
        }
    })
}

// 退出企业
const handleQuit = () =>{
    AccountServer.quitEnterprise().then((res)=>{
        if(res.code === NetCode.SUCCESS){
            call('quitEnterpriseCall')
            visible.value = false
        }else{
            Toast(res.message)
        }
    })
}

const handleInputChange = (value: string)=>{
    console.log(value)
    inputValue.value = value
}

const handleEmailInputChange = (value: string)=>{
    console.log(value)
    memberForm.value.email = value
}

const handleAliasInputChange = (value: string)=>{
    console.log(value)
    memberForm.value.alias = value
}

const handleCancel = ()=>{
    if (deletingMember.value) return
    visible.value = false
}

const open = (type: number, params?: any) =>{
    removalRevision++
    mode.value = type
    visible.value = true
    dissolveChecked.value = false
    exitChecked.value = false
    deletingMember.value = false

    clearForm()
    console.log(type, params)
    initMemberRole(type, params)
    if (type === 3) restoreRemoval()
}

onBeforeUnmount(() => { removalRevision++ })

function clearForm(){
    memberForm.value = {
        email: '',
        alias: '',
        role: null,
        fileLook: false,
        fileEdit: false,
        fileDownload: false,
        artUse: false,
        artEdit: false
    }
}
function initMemberRole(type: number, params?: any){
    // 编辑和添加成员
    if (type == 1 || type == 2) {
        // 初始化编辑数据
        if (params) {
            initEdit(params)
        }
        // 如果我是创建者 可以设置管理员和成员
        if (userInfo.value.bizTeamMemberRole == 1) {
            options.value = [
                {value: 2, label: t('account_enterprise_add_member_role_admin')},
                {value: 3, label: t('account_enterprise_table_header_member')}
            ]
        }else{
            options.value = [
                {value: 3, label: t('account_enterprise_table_header_member')}
            ]
        }
        if (type == 1) {
            emailInput.value && emailInput.value.clearInput()
            aliasInput.value && aliasInput.value.clearInput()
        }
    }else if (type == 3) {
        currentMember.value = params
    }
}

function initEdit(params: any){
    memberForm.value.fileLook = false
    memberForm.value.fileEdit = false
    memberForm.value.fileDownload = false
    memberForm.value.artUse = false
    memberForm.value.artEdit = false
    if (PermissionUtils.hasPermission(params.permission, EnterpriseMemberPermission.FILE_LOOK)) {
        memberForm.value.fileLook = true
    }
    if (PermissionUtils.hasPermission(params.permission, EnterpriseMemberPermission.FILE_EDIT)) {
        memberForm.value.fileEdit = true
    }
    if (PermissionUtils.hasPermission(params.permission, EnterpriseMemberPermission.FILE_DOWNLOAD)) {
        memberForm.value.fileDownload = true
    }
    if (PermissionUtils.hasPermission(params.permission, EnterpriseMemberPermission.TERM_USE)) {
        memberForm.value.artUse = true
    }
    if (PermissionUtils.hasPermission(params.permission, EnterpriseMemberPermission.TERM_EDIT)) {
        memberForm.value.artEdit = true
    }
    memberForm.value.email = params.userAccount
    memberForm.value.alias = params.aliasName || ""
    memberForm.value.role = params.roleType
    memberForm.value.id = params.id

    emailInput.value && emailInput.value.setInputValue(memberForm.value.email)
    aliasInput.value && aliasInput.value.setInputValue(memberForm.value.alias)
}

function checkAddMember(){
    console.log("checkAddMember", memberForm.value)
    if(memberForm.value.email === ''){
        return false
    }
    if(memberForm.value.role === 0 || memberForm.value.role === null){
        return false
    }
    return true
}

function handleMemberSave(){
    if(!checkAddMember()){
        return
    }
    let permission = 0
    if (memberForm.value.fileLook) {
        permission = PermissionUtils.addPermission(permission, EnterpriseMemberPermission.FILE_LOOK)
    }
    if (memberForm.value.fileEdit) {
        permission = PermissionUtils.addPermission(permission, EnterpriseMemberPermission.FILE_EDIT)
    }
    if (memberForm.value.fileDownload) {
        permission = PermissionUtils.addPermission(permission, EnterpriseMemberPermission.FILE_DOWNLOAD)
    }
    if (memberForm.value.artUse) {
        permission = PermissionUtils.addPermission(permission, EnterpriseMemberPermission.TERM_USE)
    }
    if (memberForm.value.artEdit) {
        permission = PermissionUtils.addPermission(permission, EnterpriseMemberPermission.TERM_EDIT)
    }
    if (mode.value == 1) {
        // 添加成员
        AccountServer.addMember({
            inviteAccount: memberForm.value.email,
            aliasName: memberForm.value.alias,
            permission: `${permission}`,
            roleType: memberForm.value.role
        }).then((res)=>{
            console.log(res)
            if (res.code === NetCode.SUCCESS) {
                call('addMemberCall')
                visible.value = false
            }else {
                Toast(res.message)
            }
        }).catch((res)=>{
            if (res.message) {
                Toast(res.message)
            }
        })
    }else if (mode.value == 2) {
        // 编辑成员
        AccountServer.editMember({
            memberId: memberForm.value.id,
            aliasName: memberForm.value.alias,
            permission: `${permission}`,
            roleType: memberForm.value.role
        }).then((res)=>{
            console.log(res)
            if (res.code === NetCode.SUCCESS) {
                call('editMemberCall')
                visible.value = false
            }
        })
    }
}

onMounted(()=>{
    
})
defineExpose({
    open
})
</script>

<style lang="scss" scoped>
.desktop-create-content{
    width: 400px;
    height: 232px;
    padding: 24px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    .create-content-title {
        font-size: 16px;
        font-weight: bold;
        color: #262626;
        margin-top: 16px;
    }
    .create-content-sub_title {
        font-size: 14px;
        color: #262626;
        margin-top: 16px;
    }
    .create-content-input {
        margin-top: 20px;
        width: 100%;

        .create-content-input-title {
            font-size: 14px;
            color: #262626;
            
            text-align: center;
        }
    }
    .create-content-button {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        gap: 10px;
        .create-content-button-item_cancel {
            width: 50%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border: 1px solid #2590E1;
            border-radius: 4px;
            cursor: pointer;
            .create-content-button-item_cancel_text {
                font-size: 14px;
                color: #2590E1;
            }
            &:hover {
                opacity: 0.7;
            }
        }
        .create-content-button-item_confirm {
            width: 50%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #2590E1;
            border-radius: 4px;
            cursor: pointer;
            .create-content-button-item_confirm_text {
                font-size: 14px;
                color: #fff;
            }
            &:hover {
                opacity: 0.7;
            }
        }
    }
}

.desktop-add-member-content{
    width: 400px;
    height: 422px;
    padding: 24px;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    .add-member-content-title {
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        margin-top: 16px;
        width: 100%;
        text-align: center;
    }
    .add-member-content-sub_title {
        font-size: 14px;
        color: #262626;
        margin-top: 16px;
    }
    .add-member-content-input {
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        .add-member-content-input-title {
            font-size: 14px;
            color: #262626;
            .import-title {
                color: #E14C25;
                line-height: 20px;
            }
        }
        .add-member-content-input-item {
            display: flex;
            flex: 1;
            align-items: center;
        }
    }
    .add-member-content-select {
        margin-top: 20px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        .add-member-content-select-title {
            font-size: 14px;
            color: #262626;
            .import-title {
                color: #E14C25;
                line-height: 20px;
            }
        }
        .add-member-content-select-item {
            display: flex;
            flex: 1;
            align-items: center;
            .custom-select {
                width: 100%;
                border-radius: 4px;
            }
        }
    }
    .permission-content-select {
        margin-top: 30px;
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 10px;
        .permission-content-select-title {
            font-size: 14px;
            color: #262626;
            .import-title {
                color: #E14C25;
                line-height: 20px;
            }
        }
        .permission-content-select-item {
            display: flex;
            flex: 1;
            flex-direction: column;
            .permission-content-select-item-box {
                display: flex;
                flex-direction: row;
                .permission-content-select-item-title-box { 
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    min-width: 60px;
                    height: 20px;
                    .permission-content-select-item-title-box-title {
                        font-size: 12px;
                        color: #262626;
                    }
                    .icon-icon_question {
                        font-size: 14px;
                        color: #8C8C8C;
                        margin-left: 4px;
                    }
                    .popoverDiv {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        .title {
                            color: white;
                            font-size: 12px;
                        }
                    }
                }
                .permission-checkbox {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin: 0 5px;
                    .checkDev_tipsTitle {
                        font-size: 12px;
                        color: #595959;
                        font-weight: 400;
                    }
                    .icon-icon_nchecked_n {
                        font-size: 16px;
                        color: #595959;
                        padding: 0 5px;
                    }
                    &:hover .icon-icon_nchecked_n {
                        color: #2590E1;
                    }
                    .icon-icon_check_n {
                        font-size: 16px;
                        color: #2590E1;
                        padding: 0 5px;
                    }
                    &:hover .icon-icon_check_n {
                        color: #2590E1
                    }
                    .icon-icon_selected {
                        cursor: pointer;
                        font-size: 18px;
                        color: #2590E1;
                        padding: 0 5px;
                    }
                }
            }
            .custom-select {
                width: 100%;
                border-radius: 4px;
            }
        }
    }
    .add-member-content-button {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        gap: 10px;
        .add-member-content-button-item_confirm {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #2590E1;
            border-radius: 4px;
            cursor: pointer;
            .add-member-content-button-item_confirm_text {
                font-size: 14px;
                color: #fff;
            }
            &:hover {
                opacity: 0.7;
            }
        }
        .add-member-content-button-item_confirm-disabled {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #D3E9F9;
            border-radius: 4px;
        }
    }
    .back-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
        &:hover {
            opacity: 0.7;
        }
    }
}

// ======================== 解散/退出企业自定义弹窗样式 ========================
.enterprise-dialog {
    box-sizing: border-box;
    width: 500px;
    max-width: 90vw;
    background: #FFFFFF;
    border-radius: 14px;
    box-shadow: 0 16px 44px rgba(10, 35, 77, 0.2);
    padding: 26px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    overflow: hidden;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;

    .enterprise-dialog-title {
        font-size: 18px;
        font-weight: 800;
        color: #1F2329;
        text-align: center;
        white-space: nowrap;
        line-height: normal;
    }

    .enterprise-dialog-desc {
        font-size: 13px;
        line-height: 1.6;
        color: #51565D;
        text-align: center;
        width: 100%;
    }

    .enterprise-dialog-check-row {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 14px 16px;
        background: #F7F9FC;
        border: 1px solid #E3E7EC;
        border-radius: 10px;
        cursor: pointer;
    }

    .enterprise-dialog-checkbox {
        box-sizing: border-box;
        width: 15px;
        height: 15px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFFFFF;
        border: 1px solid #C3C9D1;
        border-radius: 3px;

        &.enterprise-dialog-checked {
            background: #2B7DE9;
            border-color: #2B7DE9;
        }
    }

    .enterprise-dialog-check-text {
        flex: 1;
        font-size: 12.5px;
        line-height: 1.6;
        color: #1F2329;
        font-weight: 600;
    }

    .enterprise-dialog-btns {
        width: 100%;
        height: 44px;
        display: flex;
        gap: 14px;
    }

    .enterprise-dialog-btn-cancel {
        appearance: none;
        box-sizing: border-box;
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #FFFFFF;
        border: 1px solid #2B7DE9;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 700;
        color: #2B7DE9;
        font-family: inherit;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
            background: #F0F7FF;
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.55;
        }
    }

    .enterprise-dialog-btn-confirm {
        appearance: none;
        box-sizing: border-box;
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #EDEFF2;
        border: 0;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 700;
        color: #A8B0BA;
        font-family: inherit;
        cursor: not-allowed;
        white-space: nowrap;

        &.enterprise-dialog-enabled {
            background: #E5484D;
            color: #FFFFFF;
            cursor: pointer;

            &:hover {
                background: #D94045;
            }
        }

        &.enterprise-dialog-submitting {
            background: #F08A8E;
            cursor: not-allowed;
        }
    }

    .enterprise-dialog-status-tip {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;

        svg {
            width: 12px;
            height: 12px;
        }
    }

    .enterprise-dialog-status-icon {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        background-color: currentColor;
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: contain;
        -webkit-mask-position: center;
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-size: contain;
    }

    .enterprise-dialog-status-icon-info {
        color: #8F959E;
        mask-image: url('@/assets/images/enterprise/icons/info.svg');
        -webkit-mask-image: url('@/assets/images/enterprise/icons/info.svg');
    }

    .enterprise-dialog-status-icon-warning {
        color: #E5484D;
        mask-image: url('@/assets/images/enterprise/icons/triangle-alert.svg');
        -webkit-mask-image: url('@/assets/images/enterprise/icons/triangle-alert.svg');
    }

    .enterprise-dialog-tip-text {
        font-size: 11.5px;
        line-height: normal;
        white-space: nowrap;
    }

    .enterprise-dialog-tip-gray {
        color: #8F959E;
        font-weight: 400;
    }

    .enterprise-dialog-tip-danger {
        color: #E5484D;
        font-weight: 400;
    }

    .enterprise-dialog-tip-orange {
        color: #C2410C;
        font-weight: 600;
    }

    .check-svg {
        display: block;
        width: 11px;
        height: 11px;
    }

    &.enterprise-remove-dialog {
        .enterprise-dialog-desc {
            min-height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            word-break: break-word;
        }
    }
}

</style>

<style lang="scss">
.el-dialog.enterprise-dissolve-dialog-host {
    width: 500px !important;
    max-width: 90vw !important;
    padding: 0 !important;
    background: transparent !important;
    border-radius: 14px !important;
    box-shadow: none !important;
    overflow: visible !important;

    .el-dialog__header,
    .el-dialog__body {
        padding: 0 !important;
        margin: 0 !important;
        background: transparent !important;
    }
}
</style>

<style scoped>

.custom-select :deep(.el-select__wrapper){
    box-shadow: none !important;
    padding: 8px 20px !important;
    min-height: 42px !important;
    box-shadow: 0 0 0 1px #BFBFBF inset !important;

}
</style>
